const cardProductSlider = customElements.get('card-product-slider');

if (cardProductSlider && !customElements.get('recently-viewed-products')) {
  class RecentlyViewed extends cardProductSlider {
    constructor() {
      super();

      this.section = this.closest('.js-section');
      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.productHandle = this.dataset.productHandle;

      this.fetchRecentProducts();
    }

    fetchRecentProducts() {
      const productHandles = localStorage.getItem('recently-viewed');

      if (!productHandles) {
        return;
      }

      const productHandlesArray = productHandles
        .split(',')
        .filter(
          (productHandle) => productHandle !== this.productHandle
        )
        .filter(Boolean);

      if (productHandlesArray.length === 0) {
        return;
      }

      productHandlesArray.forEach((productHandle, i) => {
        const addRecentProducts = async () => {
          try {
            // @ts-ignore
            const url = `${window.Shopify.routes.root}products/${productHandle}?view=card`;
            const productCardResponse = await fetch(url);

            const productCardHTML = await productCardResponse.text();

            const productSlide = document.createElement('DIV');

            productSlide.classList.add(
              'swiper-slide',
              'card-product-slider__slide'
            );
            productSlide.insertAdjacentHTML(
              'beforeend',
              productCardHTML
            );
            if (
              !productCardResponse.ok ||
              !productSlide.querySelector('card-product') ||
              !productSlide.querySelector('.card-product')
            ) {
              const handlesString = localStorage.getItem('recently-viewed');
              if (handlesString) {
                const handles = handlesString.split(',');
                const filteredHandles = handles.filter(
                  (h) => h !== productHandle
                );
                localStorage.setItem(
                  'recently-viewed',
                  filteredHandles.join(',')
                );
              }
              return;
            }
            if (this.sliderWrapper) {
              this.sliderWrapper.append(productSlide);
            }
          } catch (error) {
            // console.log(error);
          } finally {
            const isLastIteration =
              i === productHandlesArray.length - 1;

            if (!isLastIteration) {
              return;
            }

            // @ts-ignore
            this.initSlider();

            if (this.section) {
              this.section.classList.remove('hidden');
            }
          }
        };

        addRecentProducts();
      });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewed);
}
